<!-- <cui-button-link *ngIf="grupoUsuario" class="  btn_style option-btn pull-right only-icon" (click)="deleteUsuarioFromGroup(usuario, 0)" ><fa name="trash"></fa></cui-button-link> -->
<!-- <cui-button-link class="  btn_style option-btn pull-right only-icon" toggleExpandable="editEstudiante_{{ usuario.id }}" ><fa name="edit"></fa></cui-button-link> -->
<cui-button-link class="btn_style option-btn pull-right" (click)="resetPassword()">
    <ogr-icon name="reset-password" class="icono"></ogr-icon>
    Restablecer contraseña
</cui-button-link>
